import { useMemo } from 'react';
import { usePermissions } from 'context/PermissionsContext';
import { SMART_DOCUMENTS_PERMISSION_CODES } from 'permissions/constants/smartDocumentsPermissionCodes';
import { MODULE_KEY_MAP } from 'permissions/constants/moduleKeyMap';

export { SMART_DOCUMENTS_PERMISSION_CODES };

const usePermissionsSmartDocuments = () => {
  const { permissionsLoading, hasPermission, hasModuleAccess } =
    usePermissions();

  return useMemo(
    () => ({
      loading: permissionsLoading,
      canAccessModule: hasModuleAccess(MODULE_KEY_MAP.SMART_DOCUMENTS),
      canAccessDocumentManagement: hasPermission(
        SMART_DOCUMENTS_PERMISSION_CODES.DOCUMENT_MANAGEMENT
      ),
      canViewDocumentManagementSection: hasPermission(
        SMART_DOCUMENTS_PERMISSION_CODES.DOCUMENT_MANAGEMENT_SECTION
      ),
      canCreateSubmission: hasPermission(
        SMART_DOCUMENTS_PERMISSION_CODES.CREATE_SUBMISSION
      ),
      canDownloadManagementExcel: hasPermission(
        SMART_DOCUMENTS_PERMISSION_CODES.DOWNLOAD_MANAGEMENT_EXCEL
      ),
      canViewDocument: hasPermission(
        SMART_DOCUMENTS_PERMISSION_CODES.VIEW_DOCUMENT
      ),
      canManageAndAddComment: hasPermission(
        SMART_DOCUMENTS_PERMISSION_CODES.MANAGE_AND_ADD_COMMENT
      ),
      canCancelRequest: hasPermission(
        SMART_DOCUMENTS_PERMISSION_CODES.CANCEL_REQUEST
      ),
      canAccessDocumentRegistry: hasPermission(
        SMART_DOCUMENTS_PERMISSION_CODES.DOCUMENT_REGISTRY
      ),
      canViewDocumentRegistrySection: hasPermission(
        SMART_DOCUMENTS_PERMISSION_CODES.DOCUMENT_REGISTRY_SECTION
      ),
      canDownloadRegistryExcel: hasPermission(
        SMART_DOCUMENTS_PERMISSION_CODES.DOWNLOAD_REGISTRY_EXCEL
      ),
      canViewDetail: hasPermission(
        SMART_DOCUMENTS_PERMISSION_CODES.VIEW_DETAIL
      ),
      canDownloadDocument: hasPermission(
        SMART_DOCUMENTS_PERMISSION_CODES.DOWNLOAD_DOCUMENT
      ),
      canMarkAsLoaded: hasPermission(
        SMART_DOCUMENTS_PERMISSION_CODES.MARK_AS_LOADED
      ),
    }),
    [permissionsLoading, hasPermission, hasModuleAccess]
  );
};

export default usePermissionsSmartDocuments;
